<template>
    <div class="container" v-if="isVisible">
        <lottie-player src="https://assets1.lottiefiles.com/packages/lf20_obhph3sh.json"  background="transparent"  speed="1"  style="width: 400px; height: 300px; top: -10px; position: absolute;"  loop autoplay>
        </lottie-player>
        <figure>
            <img src="/img/coins.svg">
        </figure>
        <div class="heading"> Congratulations! </div>
        <div class="subheading">
            You have completed one year of purposeful investing with us.
        </div>
    </div>
</template>

<script>
export default {
    name: 'LockInOverMessage',
    data () {
        return {
            isVisible: true
        }
    },
    mounted () {
        setTimeout(() => {
            this.isVisible = false
        }, 10000)
    }
}
</script>

<style scoped>
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        pointer-events: none !important;
    }

    .heading {
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 24px;
        color: #002FA7;
    }

    .subheading {
        text-align: center;
        font-size: 17px;
        padding: 10px 0px;
        color: #4F4F4F;
    }
</style>
